'use client'

import { Menu, Globe, User } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  return (
    <header className="fixed top-0 left-0 right-0 bg-gradient-to-r from-[#e8f4f8] to-[#89c8e3] text-gray-800 shadow-md z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-24">
          <Link href="/" className="flex items-center gap-3">
            <Image
              src="/images/logo7.svg"
              alt="桃園市報關商業同業公會"
              width={48}
              height={48}
              className="w-12 h-12"
              priority
            />
            <div>
              <h1 className="text-xl font-bold text-gray-800">桃園市報關商業同業公會</h1>
              <p className="text-sm text-gray-600">TaoYuan Customs Brokers Association</p>
            </div>
          </Link>
          
          <nav className="hidden md:flex space-x-8">
            <Link href="/about" className="text-gray-800 hover:text-gray-600">關於我們</Link>
            <Link href="/news" className="text-gray-800 hover:text-gray-600">最新消息</Link>
            <Link href="/links" className="text-gray-800 hover:text-gray-600">友好連結</Link>
            <Link href="/vendors" className="text-gray-800 hover:text-gray-600">會員廠商</Link>
            <Link href="/contact" className="text-gray-800 hover:text-gray-600">聯絡我們</Link>
          </nav>

          <div className="flex items-center space-x-4">
            <button className="p-2 text-gray-800 hover:text-gray-600">
              <Globe className="h-5 w-5" />
            </button>
            <Link href="/login" className="flex items-center space-x-1 text-gray-800 hover:text-gray-600">
              <User className="h-5 w-5" />
              <span>管理登入</span>
            </Link>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 text-gray-800 hover:text-gray-600"
            >
              <Menu className="h-6 w-6" />
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden py-4">
            <div className="flex flex-col space-y-4">
              <Link href="/about" className="text-gray-800 hover:text-gray-600">關於我們</Link>
              <Link href="/news" className="text-gray-800 hover:text-gray-600">最新消息</Link>
              <Link href="/links" className="text-gray-800 hover:text-gray-600">友好連結</Link>
              <Link href="/vendors" className="text-gray-800 hover:text-gray-600">會員廠商</Link>
              <Link href="/contact" className="text-gray-800 hover:text-gray-600">聯絡我們</Link>
            </div>
          </nav>
        )}
      </div>
    </header>
  )
}